<form [formGroup]="formName">
    <p-calendar appendTo="body"
        [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode"
        [showIcon]="true" rangeSelection="true" hideOnDateTimeSelect="false"
        [placeholder]="'lbl_date_range' | translate" selectionMode="range" [hideOnDateTimeSelect]="true"
        [readonlyInput]="true" [dateFormat]="'dd/mm/yy'" [maxDate]="maxDate"></p-calendar>
</form>